import { defineMessages } from 'react-intl';

export default defineMessages({
    printConfirmation: {
        id: 'ml.reinstatement.common.views.ml-reinstatement-confirmation.Print Confirmation',
        defaultMessage: 'Print Confirmation'
    },
    goToAccount: {
        id: 'ml.reinstatement.common.views.ml-reinstatement-confirmation.Go To Account',
        defaultMessage: 'Go To Account'
    },
    change: {
        id: 'ml.reinstatement.common.views.ml-reinstatement-confirmation.Change',
        defaultMessage: 'Change'
    },
    policyReinstated: {
        id: 'ml.reinstatement.common.views.ml-reinstatement-confirmation.The policy has been reinstated',
        defaultMessage: 'The policy has been reinstated'
    },
    refundDue: {
        id: 'ml.reinstatement.common.views.ml-reinstatement-confirmation.Refund Due',
        defaultMessage: 'Refund Due'
    },
    amountDue: {
        id: 'ml.reinstatement.common.views.ml-reinstatement-confirmation.Amount Due',
        defaultMessage: 'Amount Due'
    },
    policyChangeScriptUppercase: {
        id: 'ml.reinstatement.common.views.ml-reinstatement-confirmation.POLICY CHANGE SCRIPT',
        defaultMessage: 'POLICY CHANGE SCRIPT'
    },
    requierdDocumentContentText: {
        id: 'ml.reinstatement.common.views.ml-reinstatement-confirmation.You must submit supporting documentation for the following:',
        defaultMessage: 'You must submit supporting documentation for the following:'
    },
    typePolicy: {
        id: 'ml.reinstatement.common.views.ml-reinstatement-confirmation.Type Policy',
        defaultMessage: '{policyType} Policy'
    },
    coverageDocumentUppercase: {
        id: 'ml.reinstatement.common.views.ml-reinstatement-confirmation.COVERAGE DOCUMENT',
        defaultMessage: 'COVERAGE DOCUMENT'
    },
    actionUppercase: {
        id: 'ml.reinstatement.common.views.ml-reinstatement-confirmation.ACTION',
        defaultMessage: 'ACTION'
    },
    yourPolicyDocuments: {
        id: 'ml.reinstatement.common.views.ml-reinstatement-confirmation.Your Policy Documents',
        defaultMessage: 'Your Policy Documents'
    },
    view: {
        id: 'ml.reinstatement.common.views.ml-reinstatement-confirmation.View',
        defaultMessage: 'View'
    },
    yourIDCards: {
        id: 'ml.reinstatement.common.views.ml-reinstatement-confirmation.Your ID Cards',
        defaultMessage: 'Your ID Cards'
    },
});